import styled, { keyframes, css } from 'styled-components'

export const Container = styled.div<{ isFullscreen?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;

  ${({ isFullscreen }) =>
    isFullscreen &&
    `
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 99999 !important;
    background: #000 !important;
    padding: 0 !important;
    margin: 0 !important;
    overflow: hidden !important;
    gap: 0 !important;
    justify-content: flex-end !important;
    align-items: center !important;
  `}
`

export const VideoContainer = styled.div<{ isFullscreen?: boolean }>`
  border-radius: ${({ isFullscreen }) => (isFullscreen ? '0' : '12px')};
  padding: 0;
  max-width: ${({ isFullscreen }) => (isFullscreen ? '100vw' : '1200px')};
  width: ${({ isFullscreen }) => (isFullscreen ? '100vw' : '100%')};
  max-height: ${({ isFullscreen }) =>
    isFullscreen ? 'calc(100vh - 100px)' : '700px'};
  height: ${({ isFullscreen }) =>
    isFullscreen ? 'calc(100vh - 100px)' : '500px'};
  position: relative;
  box-shadow: ${({ isFullscreen }) =>
    isFullscreen ? 'none' : '0px 10px 50px -5px rgba(163, 30, 102, 0.3)'};
  overflow: hidden;
  background: #000;
  flex: ${({ isFullscreen }) => (isFullscreen ? '1 1 auto' : '0 0 auto')};
  z-index: ${({ isFullscreen }) => (isFullscreen ? '99999' : 'auto')};
  min-width: ${({ isFullscreen }) => (isFullscreen ? '100vw' : 'auto')};
  min-height: ${({ isFullscreen }) =>
    isFullscreen ? 'calc(100vh - 100px)' : 'auto'};

  @media (max-width: 768px) {
    max-height: ${({ isFullscreen }) =>
      isFullscreen ? 'calc(100vh - 100px)' : '500px'};
    height: ${({ isFullscreen }) =>
      isFullscreen ? 'calc(100vh - 100px)' : '400px'};
    min-height: ${({ isFullscreen }) =>
      isFullscreen ? 'calc(100vh - 100px)' : 'auto'};
  }

  @media (max-width: 480px) {
    max-height: ${({ isFullscreen }) =>
      isFullscreen ? 'calc(100vh - 100px)' : '400px'};
    height: ${({ isFullscreen }) =>
      isFullscreen ? 'calc(100vh - 100px)' : '350px'};
    min-height: ${({ isFullscreen }) =>
      isFullscreen ? 'calc(100vh - 100px)' : 'auto'};
  }
`

export const RemoteVideo = styled.div`
  display: block;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  box-shadow:
    0 0 10px rgba(0, 0, 0, 0.7),
    0 0 20px rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;

  &.main {
    width: 100%;
    height: 100%;
    background: #000;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0;
    z-index: 0;
  }

  &.paused.main,
  &.disconnected.main {
    background: #000;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .remote-videos-grid {
    display: grid;
    width: 100%;
    height: 100%;
    gap: 8px;
    padding: 8px;
    overflow: hidden;
    place-items: stretch;
    box-sizing: border-box;
    background: #000;
  }

  .remote-videos-grid .video-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #000;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
    min-height: 0;
  }

  .remote-videos-grid .video-wrapper video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    min-width: 0;
    min-height: 0;
  }

  .remote-videos-grid .video-wrapper .video-name-label {
    position: absolute;
    bottom: 8px;
    left: 8px;
    background-color: rgba(0, 0, 0, 0.7);
    color: #ffffff;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    z-index: 10;
    pointer-events: none;
    backdrop-filter: blur(4px);
    max-width: calc(100% - 16px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const LocalVideo = styled.div<{ isFullscreen?: boolean }>`
  background: #000;
  overflow: hidden;
  cursor: pointer;
  box-shadow:
    0 0 10px rgba(0, 0, 0, 0.7),
    0 0 20px rgba(0, 0, 0, 0.5);

  &.secondary {
    width: ${({ isFullscreen }) => (isFullscreen ? '100px' : '32px')};
    height: ${({ isFullscreen }) => (isFullscreen ? '130px' : '60px')};
    background: #000;
    position: absolute;
    bottom: ${({ isFullscreen }) => (isFullscreen ? '20px' : '14px')};
    right: ${({ isFullscreen }) => (isFullscreen ? '18px' : '14px')};
    border-radius: 8px;
    z-index: 1;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (min-width: 520px) {
    &.secondary {
      width: ${({ isFullscreen }) => (isFullscreen ? '160px' : '100px')};
      height: ${({ isFullscreen }) => (isFullscreen ? '140px' : '80px')};
    }
  }

  @media (max-width: 480px) {
    &.secondary {
      width: ${({ isFullscreen }) => (isFullscreen ? '100px' : '100px')};
      height: ${({ isFullscreen }) => (isFullscreen ? '130px' : '60px')};
    }
  }
`

export const Placeholder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  z-index: 10;
  pointer-events: none;

  ${RemoteVideo}.main & {
    z-index: 1;
  }

  ${LocalVideo} & {
    z-index: 1;
    background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  }
`

export const PlaceholderContent = styled.div<{ isLocal?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ isLocal }) => (isLocal ? '8px' : '40px')};
  text-align: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  img,
  svg {
    animation: pulse 2s ease-in-out infinite;
    margin-bottom: 0;
    opacity: 0.6;
    flex-shrink: 0;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 0.6;
      transform: scale(1);
    }
    50% {
      opacity: 0.8;
      transform: scale(1.05);
    }
  }
`

export const PlaceholderTitle = styled.p<{ isLocal?: boolean }>`
  color: #ffffff;
  font-size: ${({ isLocal }) => (isLocal ? '1.2rem' : '1.5rem')};
  font-weight: 500;
  margin: 0 0 8px 0;

  @media (max-width: 768px) {
    font-size: ${({ isLocal }) => (isLocal ? '1rem' : '1.3rem')};
  }

  @media (max-width: 480px) {
    font-size: ${({ isLocal }) => (isLocal ? '0.9rem' : '1.1rem')};
  }
`

export const PlaceholderSubtitle = styled.p<{ isLocal?: boolean }>`
  color: #ffffff;
  font-size: ${({ isLocal }) => (isLocal ? '0.9rem' : '1.1rem')};
  opacity: 0.7;
  text-align: center;
  max-width: ${({ isLocal }) => (isLocal ? '200px' : '300px')};
  margin: 0;

  @media (max-width: 768px) {
    font-size: ${({ isLocal }) => (isLocal ? '0.8rem' : '1rem')};
    max-width: ${({ isLocal }) => (isLocal ? '150px' : '250px')};
  }

  @media (max-width: 480px) {
    font-size: ${({ isLocal }) => (isLocal ? '0.75rem' : '0.9rem')};
    max-width: ${({ isLocal }) => (isLocal ? '120px' : '200px')};
  }
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  text-align: center;
`

export const ErrorTitle = styled.p`
  color: #ffffff;
  font-size: 1.4rem;
  font-weight: 500;
  margin-bottom: 10px;
`

export const ErrorSubtitle = styled.p`
  color: #ffffff;
  font-size: 1.2rem;
  opacity: 0.8;
`

export const CameraTest = styled.div<{ error?: boolean; warning?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  position: absolute;
  left: 0;
  top: 0;
  background: ${({ error, warning }) =>
    error ? '#FFECF0' : warning ? '#FEF3E5' : '#ecfdf3'};
  color: ${({ error, warning }) =>
    error ? '#FF4242' : warning ? '#E27A41' : '#1FBA5D'};
  padding: 16px;
  border-radius: 12px;
  font-size: 1.4rem;
  font-weight: 500;
  text-align: center;
`

export const ButtonsContainer = styled.div<{ isFullscreen?: boolean }>`
  margin-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ isFullscreen }) => (isFullscreen ? '12px' : '6px')};
  position: relative;
  width: 100%;
  height: 80px;
  z-index: ${({ isFullscreen }) => (isFullscreen ? '10000' : 'auto')};
  flex-shrink: 0;

  @media (max-width: 768px) {
    gap: 10px;
  }

  @media (max-width: 480px) {
    gap: 8px;
  }
`

const ButtonCircle = styled.button<{ disabled?: boolean; active?: boolean }>`
  width: 40px;
  height: 40px;
  cursor: ${({ disabled, active }) =>
    disabled && !active ? 'not-allowed' : 'pointer'};
  border: none;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
  z-index: 3;

  img {
    width: 18px;
    height: 18px;
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;

    img {
      width: 16px;
      height: 16px;
    }
  }

  @media (max-width: 480px) {
    width: 32px;
    height: 32px;

    img {
      width: 14px;
      height: 14px;
    }
  }
`

export const NetworkQualityButton = styled(ButtonCircle)<{
  isPoor?: boolean
  isUnstable?: boolean
}>`
  background-color: ${({ isPoor, isUnstable }) =>
    isPoor ? '#FFECF0' : isUnstable ? '#FEF3E5' : '#E6F7EB'};
  padding: 0;
`

export const FullscreenButton = styled(ButtonCircle)<{ active?: boolean }>`
  background-color: ${({ disabled, active }) =>
    disabled && !active ? '#d3d3d3' : active ? '#FF5100' : '#FFE0B9'};

  &:hover {
    background-color: ${({ disabled, active }) =>
      disabled && !active ? '#d3d3d3' : active ? '#FF5100' : '#ffd4a3'};
  }

  img {
    opacity: ${({ active }) => (active ? 1 : 0.8)};
    width: 20px;
    height: 20px;
  }
`

export const SettingsButton = styled(ButtonCircle)<{ active?: boolean }>`
  background-color: ${({ disabled, active }) =>
    disabled && !active ? '#d3d3d3' : active ? '#FF5100' : '#FFE0B9'};

  &:hover {
    background-color: ${({ disabled, active }) =>
      disabled && !active ? '#d3d3d3' : active ? '#FF5100' : '#ffd4a3'};
  }

  img {
    opacity: ${({ active }) => (active ? 1 : 0.8)};
  }
`

export const ToggleButton = styled(ButtonCircle)<{ active?: boolean }>`
  background-color: ${({ active, disabled }) => {
    if (disabled && !active) return '#d3d3d3'
    if (active) return '#786F8D'
    return '#FFE0B9'
  }};

  &:hover {
    background-color: ${({ active, disabled }) => {
      if (disabled && !active) return '#d3d3d3'
      if (active) return '#5a5169'
      return '#ffd4a3'
    }};
  }
`

export const EndButton = styled(ButtonCircle)<{ disabled?: boolean }>`
  width: 48px;
  height: 48px;
  background-color: ${({ disabled }) => (disabled ? '#d3d3d3' : '#EF3840')};

  &:hover {
    background-color: ${({ disabled }) => (disabled ? '#d3d3d3' : '#a30e2d')};
  }

  img {
    width: 32px;
    height: 32px;
  }

  @media (max-width: 768px) {
    width: 44px;
    height: 44px;

    img {
      width: 28px;
      height: 28px;
    }
  }

  @media (max-width: 480px) {
    width: 40px;
    height: 40px;

    img {
      width: 24px;
      height: 24px;
    }
  }
`

export const BackgroundButtons = styled.div<{ isFullscreen?: boolean }>`
  align-self: center;
  margin-top: ${({ isFullscreen }) => (isFullscreen ? '0' : '2px')};
  margin-bottom: ${({ isFullscreen }) => (isFullscreen ? '0' : '0')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ isFullscreen }) => (isFullscreen ? '12px' : '8px')};
  border: 0.5px solid #c0b7d8;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  padding: ${({ isFullscreen }) => (isFullscreen ? '12px 20px' : '4px 6px')};
  flex-wrap: ${({ isFullscreen }) => (isFullscreen ? 'nowrap' : 'wrap')};
  max-width: ${({ isFullscreen }) => (isFullscreen ? 'none' : '90%')};
  width: ${({ isFullscreen }) => (isFullscreen ? 'auto' : '100%')};
  flex-shrink: 0;
  position: ${({ isFullscreen }) => (isFullscreen ? 'absolute' : 'static')};
  z-index: ${({ isFullscreen }) => (isFullscreen ? '999999' : 'auto')};
  bottom: ${({ isFullscreen }) => (isFullscreen ? '100px' : 'auto')};
  left: ${({ isFullscreen }) => (isFullscreen ? '50%' : 'auto')};
  transform: ${({ isFullscreen }) =>
    isFullscreen ? 'translateX(-50%)' : 'none'};

  @media (max-width: 768px) {
    gap: ${({ isFullscreen }) => (isFullscreen ? '10px' : '8px')};
    padding: ${({ isFullscreen }) => (isFullscreen ? '10px 16px' : '8px 12px')};
    bottom: ${({ isFullscreen }) => (isFullscreen ? '110px' : 'auto')};
    max-width: ${({ isFullscreen }) => (isFullscreen ? 'none' : '100%')};
  }

  @media (max-width: 520px) {
    max-width: ${({ isFullscreen }) => (isFullscreen ? 'none' : '100%')};
    overflow-x: ${({ isFullscreen }) => (isFullscreen ? 'visible' : 'auto')};
    overflow-y: hidden;
    padding: ${({ isFullscreen }) => (isFullscreen ? '20px 8px' : '10px 8px')};
    gap: ${({ isFullscreen }) => (isFullscreen ? '8px' : '6px')};
    bottom: ${({ isFullscreen }) => (isFullscreen ? '100px' : 'auto')};
  }
`

export const BackgroundButton = styled.button<{ isFullscreen?: boolean }>`
  width: ${({ isFullscreen }) => (isFullscreen ? '40px' : '50px')};
  height: ${({ isFullscreen }) => (isFullscreen ? '40px' : '50px')};
  padding: 0;
  border-radius: 12px;
  border: none;
  background-color: #ffe0b9;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.2s;
  flex-shrink: 0;

  &:hover {
    transform: scale(1.05);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }

  @media (max-width: 768px) {
    width: ${({ isFullscreen }) => (isFullscreen ? '36px' : '44px')};
    height: ${({ isFullscreen }) => (isFullscreen ? '36px' : '44px')};
  }

  @media (max-width: 520px) {
    width: ${({ isFullscreen }) => (isFullscreen ? '32px' : '40px')};
    height: ${({ isFullscreen }) => (isFullscreen ? '32px' : '40px')};
  }

  @media (max-width: 480px) {
    width: ${({ isFullscreen }) => (isFullscreen ? '32px' : '38px')};
    height: ${({ isFullscreen }) => (isFullscreen ? '32px' : '38px')};
  }
`

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
`

const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
`

export const NetworkMessage = styled.div<{
  isPoor?: boolean
  isUnstable?: boolean
  isRisky?: boolean
  overallQuality?: number
  connectionStatus?: string
}>`
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1001;
  background: ${({ connectionStatus, isPoor, isUnstable, isRisky }) => {
    if (
      connectionStatus === 'disconnected' ||
      connectionStatus === 'critical' ||
      isPoor
    ) {
      return 'linear-gradient(135deg, #FFECF0 0%, #FFD6DC 100%)'
    }
    if (connectionStatus === 'poor' || isUnstable) {
      return 'linear-gradient(135deg, #FEF3E5 0%, #FFE8CC 100%)'
    }
    if (connectionStatus === 'good' || isRisky) {
      return 'linear-gradient(135deg, #E6F7EB 0%, #D4F4E0 100%)'
    }
    return 'linear-gradient(135deg, #E6F7EB 0%, #D4F4E0 100%)'
  }};
  border-radius: 12px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.2px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.12),
    0 2px 4px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid
    ${({ connectionStatus, isPoor, isUnstable }) => {
      if (
        connectionStatus === 'disconnected' ||
        connectionStatus === 'critical' ||
        isPoor
      ) {
        return 'rgba(208, 38, 50, 0.2)'
      }
      if (connectionStatus === 'poor' || isUnstable) {
        return 'rgba(226, 122, 65, 0.2)'
      }
      return 'rgba(19, 170, 83, 0.2)'
    }};
  animation: ${slideDown} 0.3s ease-out;
  transition: all 0.3s ease;
  min-width: 200px;
  justify-content: center;

  ${({ connectionStatus }) =>
    connectionStatus === 'poor' ||
    connectionStatus === 'critical' ||
    connectionStatus === 'disconnected'
      ? css`
          animation:
            ${slideDown} 0.3s ease-out,
            ${pulse} 2s infinite 0.3s;
        `
      : css`
          animation: ${slideDown} 0.3s ease-out;
        `}

  span {
    white-space: nowrap;
    user-select: none;
    line-height: 1.4;
    display: inline-block;
    color: ${({ connectionStatus, isPoor, isRisky }) => {
      if (
        connectionStatus === 'disconnected' ||
        connectionStatus === 'critical' ||
        isPoor
      ) {
        return '#D02632'
      }
      if (connectionStatus === 'poor') {
        return '#E27A41'
      }
      if (connectionStatus === 'good' || isRisky) {
        return '#E27A41'
      }
      return '#13AA53'
    }};
    font-weight: 600;
  }

  @media (max-width: 768px) {
    top: 16px;
    padding: 10px 16px;
    font-size: 13px;
    min-width: 180px;
    gap: 8px;
  }

  @media (max-width: 480px) {
    top: 12px;
    padding: 8px 14px;
    font-size: 12px;
    min-width: 160px;
    gap: 6px;
  }
`

export const NetworkBars = styled.div`
  display: flex;
  align-items: end;
  gap: 2px;
  height: 16px;
  justify-content: center;
`

export const NetworkBar = styled.div<{
  isActive?: boolean
  barNumber?: number
  isPoor?: boolean
  isUnstable?: boolean
  isRisky?: boolean
}>`
  width: 3px;
  height: ${({ barNumber }) => (barNumber ? `${barNumber * 4 + 2}px` : '6px')};
  background-color: ${({ isActive, isPoor, isUnstable, isRisky }) => {
    if (!isActive) return '#E5E5E5'
    if (isPoor) return '#D02632'
    if (isRisky) return '#E27A41'
    if (isUnstable) return '#E27A41'
    return '#13AA53'
  }};
  border-radius: 1.5px;
  opacity: ${({ isActive }) => (isActive ? 1 : 0.4)};
`
